import { HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { OnboardingStore } from "../../features/onboarding/state/onboarding-state.store";
import { environment } from "../../../environment/environment";
import { jwtDecode } from "jwt-decode";
import { firstValueFrom, map } from "rxjs";
import { AuthStore } from "../store/authentication/authentication.store";

interface Provider {
    id: number;
    first_name: string;
    last_name: string;
    npi: string
    email_address: string
}

export const accessGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router)
    const http = inject(HttpClient)
    const onboardingStore = inject(OnboardingStore)
    const authStore = inject(AuthStore)
    const routeBase = environment.apiBase

    try {
        authStore.setLoading(true);
        const authTokens = localStorage.getItem('auth_tokens')



        if(!authTokens) {
            return router.createUrlTree(['/login'])
        }
        const idToken = JSON.parse(authTokens).idToken

        const decoded: any = jwtDecode(idToken)
        const groups: string[] = decoded['cognito:groups'] || [];


        

        // if for some reason they do not have an access group, they should never be able to gain access to the app
        if (!groups.length) {
            return router.createUrlTree(['/login']);
        }

        if (groups.includes('admin')) {
            return true
        }


        const provider: any = await firstValueFrom(
            http.get(`${routeBase}/provider`)
        );

        onboardingStore.updateDemographics(
            provider.clinic_id,
            provider.provider_id
        );


        if (groups.includes('admin-provider')) {
            const status = await firstValueFrom(
                http
                .get<{ onboarding_status: number }>(
                    `${routeBase}/clinic/${provider.clinic_id}/provider/${provider.provider_id}/onboarding-status`
                )
                .pipe(map(res => res.onboarding_status))
            );

            onboardingStore.updateOnboarding(status);

            switch (status) {
                case 0:
                    return router.createUrlTree(['/onboarding/demographics']);

                case 1:
                    return router.createUrlTree(['/onboarding/locations']);

                case 2:
                    return router.createUrlTree(['/onboarding/providers']);

                case 3:
                    return router.createUrlTree(['/onboarding/fee-schedule']);

                case 4:
                    return router.createUrlTree(['/onboarding/malpractice']);

                case 5:
                    return router.createUrlTree(['/splash']);

                case 6:
                // allow navigation to originally requested route
                    return true;

                default:
                    return router.createUrlTree(['/login']);
            }

        }

        // admin group was no recognized
        return router.createUrlTree(['/login']);

    } catch (error) {
        console.error('Access guard error:', error);
        return router.createUrlTree(['/login']);
    } finally {
        authStore.setLoading(false)
    }
}
